import React from 'react';
const AboutSection = () => {
  return <section id="story" className="py-16 px-6 md:px-12 lg:px-24" data-id="element-11">
      <div className="border-t border-gray-300 w-full mb-12" data-id="element-12"></div>
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif leading-tight max-w-5xl" data-id="element-13">
        Maverick Legacy Foundation was founded with a bold mission: to birth the
        imagination of leaders into reality. We exist to equip, inspire, and
        support individuals who are ready to make an impact in their families,
        communities, and beyond.
      </h2>
    </section>;
};
export default AboutSection;